import React, { useEffect } from 'react';
import gsap from "gsap";

const OurApproach = ({ title, OurApproachData, bgColors }) => {

   useEffect(() => {

      const mm = gsap.matchMedia(); // MatchMedia for responsive animations

      mm.add("(min-width: 768px)", () => {
         const spacer = 80;
         const tl = gsap.timeline({
            scrollTrigger: {
               trigger: ".project__slider",
               pin: true,
               scrub: true,
               start: "top 20%",
               end: "bottom 20%",
            }
         });
         tl.fromTo(
            ".project__item:not(:first-child)",
            {
               x: (index) => window.innerWidth / 1 + spacer * index,
               stagger: 0.5
            },
            {
               x: (index) => spacer * (index + 1),
               stagger: 0.2
            }
         ).fromTo(
            ".project__item:not(:last-child) .project__content",
            {
               left: "0px",
               bottom: "0px",
               rotation: 0,
            },
            {
               rotation: -90,
               ease: "power2.inOut",
               left: "65px",
               bottom: "-10px",
               stagger: 0.2
            },
            "<"
         ).fromTo(
            ".project__item:not(:last-child) .project__no",
            {
               left: "0px",
               top: "0px",
            },
            {
               ease: "power2.inOut",
               left: "-300px",
               top: "0px",
               stagger: 0.2
            },
            "<"
         );
      });

      mm.add("(max-width: 767px)", () => {
         const spacer = 70;
         // Mobile view: Bottom-to-top animation
         const tl = gsap.timeline({
            scrollTrigger: {
               trigger: ".project__slider",
               pin: true,
               scrub: true,
               start: "top 15%",
               end: "bottom 30%",
            }
         });
         tl.fromTo(
            ".project__item:not(:first-child)",
            {
               y: (index) => window.innerHeight + spacer * index,
               stagger: 0.5
            },
            {
               y: (index) => spacer * (index + 1),
               stagger: 0.1
            }
         ).fromTo(
            ".project__item:not(:last-child) .project__content",
            {
               left: "0px",
               bottom: "0px",
               rotation: 0,
            },
            {
               rotation: 0,
               ease: "power2.inOut",
               left: "0px",
               bottom: "0px",
               stagger: 0.2
            },
            "<"
         ).fromTo(
            ".project__item:not(:last-child) .project__no",
            {
               left: "0px",
               top: "0px",
            },
            {
               ease: "power2.inOut",
               left: "0px",
               top: "0px",
               stagger: 0.2
            },
            "<"
         );
      });

      return () => {
         mm.revert(); // Clean up matchMedia listeners on unmount
      };
   }, []);



   return (
      <>
         <section className="project__area pt-115 pb-120">
            <div className="tw-container tw-mx-auto">
               <div className='project__slider'>
                  <div className="tw-flex tw-flex-wrap tw--mx-3 tw-justify-between tw-items-center tw-h-full">
                     <div className="tw-w-full tw-px-3 xl:tw-w-4/12">
                        <div className="section__title section__title-3">
                           <span>{title}</span>
                           <h2>Tailored solutions for <br /> exceptional business <br />
                              success</h2>
                        </div>
                     </div>
                     {OurApproachData && (
                        <div className="tw-w-full tw-px-3 xl:tw-w-7/12 tw-h-full">
                           {OurApproachData.map((item, index) => {
                              return <div key={index} className="project__item" style={{ backgroundColor: bgColors[index % bgColors.length] }}>
                                 <div className="project__content">
                                    {item.title}
                                    <p>{item.content}</p>
                                 </div>
                                 <div className="project__no">
                                    <h5>{item.id}</h5>
                                 </div>
                                 <div className="project__icon">
                                    <img src={item.img} alt="Icon" />
                                 </div>
                              </div>
                           })}
                        </div>
                     )}
                  </div>
               </div>
            </div>
         </section>
      </>
   );
};

export default OurApproach;
